import React, { useState, useRef } from "react";
import Image from "next/image";
import { Grid } from "@mui/material";
import SkewedBar from "@/components/Common/SkewedBar";
import RequestSampleModalBtn from "@/components/Modal/RequestSample";
import Slider from "react-slick";
import Link from "next/link";
import AbsoluteSkewebar from "../Common/AbsoluteSkewebar";
import { JOB_LISTING_LINK } from "@/constastants/Constant";
const Expertise = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const sliderData = [
    {
      id: 1,
      image:
        "https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709112578.svg",
      title: "Innovate and Excel",
      description:
        "Be at the forefront of technological advancements, shaping the future of distribution and manufacturing. Learn and grow in a traditional sector by approaching it in non-traditional ways.",
    },
    {
      id: 2,
      image:
        "https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709112629.svg",
      title: "Out-of-the-Box ldeology",
      description:
        "The curious mindset of all Elchemists drive and nurture a culture of new ideas and innovative solutions across all our functions. If you believe there is always a better way, we're here to help you carve the path, and you belong here.",
    },
    {
      id: 3,
      image:
        "https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709112750.svg",
      title: " High Ownership",
      description:
        " At Elchemy, we believe that leadership potential exists within everyone. With our flat hierarchy and open-door policy, you can discover the leader within you and find your perfect place in our organization",
    },
    {
      id: 4,
      image:
        "https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709112799.svg",
      title: "Diverse Responsibilities:",
      description:
        " If you enjoy wearing multiple hats, embrace continuous learning, and aspire to holistic growth, you'll thrive here. We cherish the entrepreneurial spirit that is at the core of every Elchemist.",
    },
  ];

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    pauseOnHover: false,
    slidesToScroll: 1,
    beforeChange: (current, next) => setActiveSlide(next),
    autoplay: false,
    initialSlide: 0,
    vertical: true,
    verticalSwiping: true,
    appendDots: (dots) => (
      <div>
        <ul>{dots}</ul>
      </div>
    ),
    customPaging: function (i) {
      return (
        <a>
          <div className="custom-dots">
            <div
              className={`dot-container ${activeSlide === i ? "active" : ""}`}
            >
              <div className={activeSlide === i ? "outer-circle" : ""}>
                <div
                  className="inner-dot"
                  style={{
                    background: activeSlide === i ? "#EF4136" : "#B3B3B3",
                  }}
                />
              </div>
            </div>
          </div>
        </a>
      );
    },
  };
  return (
    <div className="pt-16 md:pt-28 pb-10">
      <div className="">
        <div className="flex  cursor-pointer text-3xl mb-4 sm:mb-0">
          <AbsoluteSkewebar
            text={"Why Work With Us: A Culture of Possibilities"}
          />
        </div>
        <div className="flex justify-between items-center">
          <div className="w-full flex flex-col lg:flex-row justify-between items-center py-4 md:py-10">
            <div className="w-full lg:w-[50%] md:p-4 mb-8 md:mb-0">
              <div className="">
                <Slider {...settings}>
                  {sliderData?.map((item, index) => (
                    <img
                      src={item.image}
                      alt={`Slide ${index}`}
                      key={index}
                      className=" w-full h-full object-cover rounded-[5px]  fastFadeOut "
                    />
                  ))}
                </Slider>
              </div>
            </div>
            <div className="w-full lg:w-[45%] flex items-center justify-center h-full">
              <div
                className="justify-center item-center  flex flex-col fastFadeOut "
                key={activeSlide}
              >
                <p className="text-2xl  font-mukta font-normal text-[30px] text-center md:text-left">
                  {sliderData[activeSlide]?.title}
                </p>
                <p className="mt-4 w-full  md:h-40 text-[16px] text-[#666666] font-normal  mb-6 md:mb-0 text-center md:text-left">
                  {sliderData[activeSlide]?.description}
                </p>
                <div className="flex gap-4">
                  <div>
                    <div className="w-[140px] h-[48px] flex items-center justify-center bg-red  text-[#fff] rounded-[3px]">
                      <a
                        href="https://tally.so/r/3xJz4v"
                        target="_blank"
                        rel="noopener noreferrer"
                        className=""
                      >
                        Join Us
                      </a>
                    </div>
                  </div>
                  <div>
                    <div className="w-[140px] h-[48px] flex items-center justify-center bg-white border border-[#ef4136] text-[#ef4136] rounded-[3px]">
                      <a
                        href={JOB_LISTING_LINK}
                        target="_blank"
                        rel="noopener noreferrer"
                        className=""
                      >
                        View open roles
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Expertise;
